
define('app/dashboard/account/accountApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/models/userModel',
	'app/dashboard/account/views/accountView'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		UserModel,
		AccountView){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		
		var accountView = new AccountView({model: userModel});
		accountView.render();
	};
	
	return {
		initialize: initialize
	};
});